<template>
  <modal
    :title="title"
    :open="open"
    size="full"
    @close="closeModal"
  >
    <p class="description">
      {{ renderSubtitle }}
    </p>
    <form @submit.stop.prevent="submit">
      <text-input
        v-model.trim="name"
        label="Name"
      />

      <text-input
        v-model.trim="email"
        type="email"
        label="Email"
      />

      <text-area-input
        v-model="feedbackText"
        label="Comment"
      />

      <div class="button-row">
        <btn
          type="submit"
          :loading="submitting"
          :disabled="disabled"
          loading-text="Submitting"
        >
          Submit
        </btn>

        <btn kind="secondary" @click="closeModal">
          Cancel
        </btn>
      </div>
    </form>
  </modal>
</template>

<script>
import { mapState } from 'vuex';
import firebase from 'firebase/compat/app';
import * as Sentry from '@sentry/vue';

export default {
  props: {
    title: String,
    subtitle: String,
    open: Boolean,
    card: Object,
  },

  data() {
    return {
      feedbackText: '',
      email: '',
      name: '',
      submitting: false,
    };
  },

  mounted() {
    if (this.user.email && typeof this.user.email === 'string' && !this.user.email.includes('privaterelay.appleid.com')) {
      this.email = this.user.email;
    }

    if (this.user.displayName) {
      this.name = this.user.displayName;
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    renderSubtitle() {
      if (this.card) {
        return this.card.label;
      }

      return this.subtitle;
    },

    disabled() {
      return !this.feedbackText || !this.email || !this.name;
    },
  },

  methods: {
    async submit() {
      this.submitting = true;

      try {
        const feedback = {
          text: this.feedbackText,
          email: this.email,
          name: this.name,
          source: 'web',
          uid: this.user.uid,
        };

        if (this.card) {
          feedback.card = {
            id: this.card.id,
            label: this.card.label,
          };
        }

        await firebase.functions().httpsCallable('httpZendeskTicketCreate')(feedback);
        this.$toasted.success('We got your request!');
        this.closeModal();
      } catch (e) {
        this.$toasted.error('Error submitting your feedback');
        Sentry.captureException(e);
      }

      this.submitting = false;
    },

    closeModal() {
      this.feedbackText = '';
      this.$emit('close');
    },
  },
};
</script>
